import { Reducer } from "react";

import { IAction } from "@selas/models";
import { AxiosError, AxiosResponse } from "axios";

import { initialPlannedInterventionState, IPlannedInterventionState } from "..";
import Endpoint from "../../services/api/endpoint";

const plannedInterventionsReducer: Reducer<IPlannedInterventionState, IAction> = (state: IPlannedInterventionState = initialPlannedInterventionState, action: IAction) => {
	switch (action.type) {
		case "REQUEST_GET_" + Endpoint.PlannedInterventions:
			state = {
				...state,
				isLoading: true,
				loadError: null
			};
			break;
		case "REQUEST_SUCCESS_GET_" + Endpoint.PlannedInterventions: {
			const payload: { response: AxiosResponse } = action.payload as { response: AxiosResponse };
			if (action.payload && payload.response && payload.response.data) {
				state = {
					...state,
					entities: payload.response.data
				};
			}
			break;
		}
		case "REQUEST_FAILURE_GET_" + Endpoint.PlannedInterventions: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				loadError: payload.error
			};
			break;
		}
		case "REQUEST_END_GET_" + Endpoint.PlannedInterventions:
			state = {
				...state,
				isLoading: false
			};
			break;
		case "CLEAR_GET_" + Endpoint.PlannedInterventions:
			state = {
				...state,
				entities: initialPlannedInterventionState.entities,
				isLoading: initialPlannedInterventionState.isLoading,
				loadError: initialPlannedInterventionState.loadError
			};
			break;
		case "REQUEST_PUT_" + Endpoint.InterventionsSequence:
			state = {
				...state,
				isUpdating: true,
				updateError: null
			};
			break;
		case "REQUEST_FAILURE_PUT_" + Endpoint.InterventionsSequence: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				updateError: payload.error
			};
			break;
		}
		case "REQUEST_END_PUT_" + Endpoint.InterventionsSequence:
			state = {
				...state,
				isUpdating: false
			};
			break;
		case "CLEAR_PUT_" + Endpoint.InterventionsSequence:
			state = {
				...state,
				updateError: null
			};
			break;
		default:
			return state;
	}
	return state;
};

export default plannedInterventionsReducer;
